import { render } from "./MenuTrees.vue?vue&type=template&id=ff5b9934&scoped=true"
import script from "./MenuTrees.vue?vue&type=script&lang=js"
export * from "./MenuTrees.vue?vue&type=script&lang=js"

import "./MenuTrees.vue?vue&type=style&index=0&id=ff5b9934&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5b9934"]])

export default __exports__